<main class="main-wrap">
  <div class="left-sidebar-wrapper">
    <app-micro-product-left-side-bar [industryReport]="industryReport"></app-micro-product-left-side-bar>
  </div>
  <div class="middle-wrapper">
    <app-micro-product-detail-page [industryReport]="industryReport"></app-micro-product-detail-page>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="deviceType !== 'mobile'">
    <!-- <app-micro-product-right-side-bar></app-micro-product-right-side-bar> -->
    <app-company-list-report></app-company-list-report>
  </div>
</main>
